
import { IEntity, IEntityImporter } from '@/typings/import';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { EEntityImportState, EEntityMatchType } from '@/components/Importer/enums';
import ImportsTableRow from '@/components/Importer/ImportsTableRow.vue';
import Passenger from '@/components/Passenger/models/Passenger';
import PropertyUpdateTable from '@/components/Importer/PropertyUpdateTable.vue';

@Component({
  components: {
    ImportsTableRow,
    PropertyUpdateTable,
  },
})
export default class PassengerImportsTable extends Vue {

  selectedItems: Array<IEntity<Passenger>> = [];

  pagination = {
    descending: true,
    page: 1,
    rowsPerPage: -1, // -1 for All
    sortBy: 'name',
  };

  @Prop({ required: true }) passengerImporter: IEntityImporter<Passenger>;
  @Watch('passengerImporter', { immediate: true }) onPassengerImporterChanged() {
    this.selectedItems = [];
    if (!this.passengerImporter) {
      return;
    }
    const selectedEntities = this.passengerImporter.entities.filter(x => x && x.entity).filter(e => e.selected);
    this.selectedItems = selectedEntities;
  }

  get headers() {
    return [
      { value: 'name', text: this.$t('passenger.prop.name.label', 'Name') },
      { value: 'externalId', text: this.$t('passenger.prop.externalId.label', 'External ID') },
      { value: 'ssn', text: this.$t('passenger.prop.ssn.label', 'Social Security Number') },
      { value: 'destination', text: this.$t('passenger.prop.destinations.main', 'Main Destination') },
      /*tslint:disable-next-line */
      { value: 'secondaryDestination', text: this.$t('passenger.prop.destinations.secondary', 'Secondary Destination') },
      { value: 'homeAddress', text: this.$t('passenger.prop.homeAddress.label', 'Home address') },
      { value: 'pickupAddress', text: this.$t('passenger.prop.pickupAddress.label', 'Pickup address') },
      { value: 'yearGrade', text: this.$t('passenger.prop.yearGrade.label', 'Grade') },
      { value: 'note', text: this.$t('passenger.prop.note.label', 'Notes') },
      { value: 'timitNote', text: this.$t('passenger.prop.timitNote.label', 'Timit notes to coordinators') },
    ];
  }

  get items() {
    const entities = this.passengerImporter.entities.filter(x => x && x.entity);
    return entities;
  }

  toggleAll() {
    if (this.selectedItems.length) {
      this.selectedItems = [];
      this.items.forEach(i => i.selected = false);
      return;
    }
    this.items.forEach(i => i.selected = true);
    this.selectedItems = this.items;
  }

  selectRow(row: IEntity<any>) {
    this.$emit('selectRow', row);
  }

}
